import type { PropsWithChildren, ReactNode } from 'react';

interface SidebarSectionRowProps {
    label: ReactNode | string;
}

const SidebarSectionRow = ({ label, children }: PropsWithChildren<SidebarSectionRowProps>) => (
    <li className='SidebarSectionRow'>
        <p className='SidebarSectionRow__label'>{label}</p>
        <div className='SidebarSectionRow__value'>{children}</div>
    </li>
);

export default SidebarSectionRow;
